import moment from 'moment';
import {logger} from 'lib/logger.js';
import * as CookieConsent from "vanilla-cookieconsent";
import {
  CAT_ANALYTICS,
  CAT_FUNCTIONALITY,
  CAT_NECESSARY,
  SERVICE_ANALYTICS_STORAGE
} from "./ConsentCookieDefinitions";

let IPCLIENT = '';

const getIp = async () => {
  const res = await fetch('https://ipinfo.io/json');
  const locationData = await res.json();
  return locationData.ip || '';
}

(async () => {
  IPCLIENT = await getIp();
})();

export const hiddeConfigButton = () => {
  const cookieContainer = document.querySelector('#cookieConfigB');
  cookieContainer.classList.remove("show");
}

export const showConfigButton = () => {
  const cookieContainer = document.querySelector('#cookieConfigB');
  cookieContainer.classList.add("show");
}

export const updateGtagConsent = (FROM) => {
  if (!window.gtag) {
    return;
  }
  gtag('consent', 'update', getConsentCookieSchema());
  logger.log('FROM:', FROM);
  logger.log('SERVICES:', SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS);
  logger.log('ACEPTANCE SERVICE:', CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS));
  logger.log(`ACEPTANCE CATEGORY ${CAT_ANALYTICS}:`, CookieConsent.acceptedCategory(CAT_ANALYTICS));
  logger.log(`ACEPTANCE CATEGORY: ${CAT_FUNCTIONALITY}` , CookieConsent.acceptedCategory(CAT_FUNCTIONALITY));
}

export const getConsentCookieSchema = () => {
  return {
    [CAT_NECESSARY]: 'granted',
    [CAT_ANALYTICS]: CookieConsent.acceptedCategory(CAT_ANALYTICS) ? 'granted' : 'denied',
    //[CAT_FUNCTIONALITY]: CookieConsent.acceptedCategory(CAT_FUNCTIONALITY) ? 'granted' : 'denied',
    [SERVICE_ANALYTICS_STORAGE]: CookieConsent.acceptedService(SERVICE_ANALYTICS_STORAGE, CAT_ANALYTICS) ? 'granted' : 'denied',
  }
}

export const setCookieData = () => {
  const schemaData = filterSchema(getConsentCookieSchema(),SERVICE_ANALYTICS_STORAGE);

  CookieConsent.setCookieData({
    value: {ip: IPCLIENT, ...schemaData}
  });
}

export const eraseCookies = (patrones) => {
  const splitHostname = location.hostname.split('.');
  let lastHostname = location.hostname;

  if (splitHostname.length > 2) {
    lastHostname = splitHostname.slice(-2).join('.');
  }

  const domains = [location.hostname, `.${lastHostname}`];
  for (const domain of domains) {
    CookieConsent.eraseCookies(patrones,'/', domain);
  }
}
const filterSchema = (data, keyOff) => {
  const valuesTranslate = {'granted': 'aceptada' ,'denied': 'rechazada'}
  const filterSchema = {};
  for (const [key, value] of Object.entries(data)) {
    if (key !== keyOff) {
      filterSchema[key] = valuesTranslate[value] || value;
    }
  }

  return filterSchema;
}

export const logConsent = () => {
  // Retrieve all the fields
  const cookie = CookieConsent.getCookie();
  const preferences = CookieConsent.getUserPreferences();

  // In this example we're saving only 4 fields
  const userConsent = {
    consentId: cookie.consentId,
    acceptType: preferences.acceptType,
    acceptedCategories: preferences.acceptedCategories,
    rejectedCategories: preferences.rejectedCategories,
  };

  return userConsent;
};

export const getGtagData = () => {
  if (!window.gtag) {
    return {};
  }
  return window.dataLayer.slice(-1)[0][2] || null;
}
export const getTimeExpired = (time) => {
  const nowDate = moment(Date.now());
  const date1 = moment(time);
  return date1.diff(nowDate, 'days')+1;
}

const getSchemaData = (data, expire) => {
  const schema = {};
  for (const [key, value] of Object.entries(data)) {
    schema[key] = {
      acceptance: value,
      maxage: expire
    };
  }

  return schema;
}
